module.exports = __webpack_public_path__ + "img/hw-catalog-01.d5b3e3b2.jpeg";